// @flow
import { RESORT_DESTINATION } from 'Client/cms/toolkit/constants';
import { buildProductArgs } from 'Utils/graphql';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_PRODUCT_DESTINATIONS } from 'Utils/request/requestDictionary';

export type CMSProps = {
  resortId: string,
  additionalInformation: string,
  healthFormalities: string,
  passportAndVisas: string,
};

export type PracticalInformation = {
  healthFormalities: string,
  passportAndVisas: string,
};

export type GQLProps = {
  resort: {
    title: string,
    name: string,
    description: string,
    productVideo: string,
    destination: {
      country: string,
      image: string,
      description: string,
    },
    practicalInformation: PracticalInformation,
    comfort: number,
    href: string,
    strengths: Array<string>,
  },
};

export const productDestinationResolver = {
  name: RESORT_DESTINATION,
  resolve(
    appContext: AppContext,
    props: CMSProps,
    pageContext: PageContext,
    location: ProductRouterLocation,
  ): Promise<GQLProps> {
    const { resortId: productId } = props;
    const { urlParams, queryParams } = location;
    const productArgs = buildProductArgs(productId, urlParams);

    const query = `query {
      resort(${productArgs}) {
        title
        name
        description
        productVideo
        destination { country image description }
        practicalInformation { healthFormalities passportAndVisas }
        comfort
        href(offerName : "${queryParams.offer || ''}")
        strengths
      }
    }`;

    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_PRODUCT_DESTINATIONS,
      strictErrors: false,
    });
  },
};
